import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome-one',
  templateUrl: './welcome-one.component.html',
  styleUrls: ['./welcome-one.component.css']
})
export class WelcomeOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
